import {THEMES, VS_FEATURES} from '@constants/main';
import {isVsFeatureEnabled} from '@utils/helpers';
import React, {useContext, useMemo} from 'react';
import {selectConfig, selectTheme} from '@components/appSlice';
import {useSelector} from 'react-redux';
import {selectFeatures, selectVSFeatures} from '@components/Login/userSlice';
import {getAppVariables} from '../senderTheme/appCssVars';
import {useScopedTheme} from '../../hooks/useScopedTheme';

const designV2 = 'v2';

type DesignVersionContextType = {
    designVersion: typeof designV2 | undefined;
}

export const DesignVersionContext = React.createContext<DesignVersionContextType>({
    designVersion: undefined
});

export const DesignVersionProvider = ({children}: {children: React.ReactNode}) => {
    const vsFeatures = useSelector(selectVSFeatures);
    const config = useSelector(selectConfig);
    const isDesignV2 = isVsFeatureEnabled({feature: VS_FEATURES.DESIGN_V2, vsFeatures, env: config.VS_ENV});
    const theme = useSelector(selectTheme);
    const containerRef = useScopedTheme({
        theme: theme === THEMES.LIGHT && isDesignV2 ? THEMES.V2_LIGHT : theme,
        hostAppVariables: getAppVariables()
    });

    const context: DesignVersionContextType = useMemo(() => ({
        designVersion: isDesignV2 ? designV2 : undefined
    }), [isDesignV2]);

    if (!isDesignV2) {
        return (
            <DesignVersionContext.Provider value={context}>
                {children}
            </DesignVersionContext.Provider>
        );
    }

    return (
        <DesignVersionContext.Provider value={context}>
            <div className="design-v2-container" ref={containerRef} style={{height: '100%', width: '100%'}}>
                {children}
            </div>
        </DesignVersionContext.Provider>
    );
};

export const useDesignContext = () => useContext(DesignVersionContext);
